module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages"
  }, [_c('sub-ibox-title', [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("门店列表")])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "list"
    }
  }, [_c('z-table', {
    attrs: {
      "offset": 0,
      "count": 10000,
      "total-count": _vm.envelopeList.total_count
    }
  }, [_vm._l((_vm.columns), function(item) {
    return _c('th', {
      attrs: {
        "slot": "columns"
      },
      slot: "columns"
    }, [_vm._v(_vm._s(item))])
  }), _vm._v(" "), _vm._l((_vm.envelopeList.list || []), function(item, index) {
    return _c('tr', {
      attrs: {
        "slot": "datasource"
      },
      slot: "datasource"
    }, [_c('td', [_vm._v(_vm._s(_vm.envelopeList.shop_list[item.shop_id]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("filterMoney")(item.dealing_amount)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.dealing_count))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("filterMoney")(item.use_amount)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.use_count))]), _vm._v(" "), _c('td', {
      staticClass: "operating"
    }, [_c('a', {
      staticClass: "operat-btn",
      on: {
        "click": function($event) {
          return _vm.handleShowInfo(item.shop_id)
        }
      }
    }, [_c('i', {
      staticClass: "icon-look"
    }), _c('span', [_vm._v("详情")])])])])
  })], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-023ff295","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/mp/marketing/red_packet/RedPacketShopListPage.vue
// module id = 806
// module chunks = 0